"use strict";
exports.__esModule = true;
var Messaging = /** @class */ (function () {
    function Messaging(protocols) {
        this.protocols = protocols;
    }
    /**
     * Creat a new system message
     * @param messages
     * @returns {*|Promise|axios.Promise}
     */
    Messaging.prototype.saveMessages = function (messages) {
        var path = this.protocols._getPath("framework/admin/broadcast/messages/save");
        var body = messages; // Array
        return this.protocols.apiPost(path, body);
    };
    /**
     * Update message status
     * @param messageId
     * @param isActive
     * @returns {*|Promise|axios.Promise}
     */
    Messaging.prototype.updateMessageStatus = function (messageId, isActive) {
        var path = this.protocols._getPath("framework/admin/broadcast/messages/update-status");
        var body = { messageId: messageId, isActive: isActive }; // Array
        return this.protocols.apiPost(path, body);
    };
    Messaging.prototype.adminGetAllMessages = function () {
        var path_ = this.protocols._getPath('framework/admin/broadcast/messages/list');
        return this.protocols.apiPost(path_, {});
    };
    /**
     * deletes all system messages
     * @returns {*|Promise|axios.Promise}
     */
    Messaging.prototype.deleteAllMessages = function () {
        var path_ = this.protocols._getPath('framework/admin/broadcast/messages/delete');
        return this.protocols.apiDelete(path_);
    };
    /**
     * delete single message by id
     * @param id
     * @returns {*|Promise|axios.Promise}
     */
    Messaging.prototype.deleteListOfMessages = function (idList) {
        var path_ = this.protocols._getPath('framework/admin/broadcast/messages/delete');
        var body_ = idList;
        return this.protocols.apiPost(path_, body_);
    };
    Messaging.prototype.getMessages = function () {
        var path_ = this.protocols._getPath('framework/broadcast/messages/list');
        return this.protocols.apiPost(path_, {});
    };
    return Messaging;
}());
exports["default"] = Messaging;
//# sourceMappingURL=messaging.js.map


// WEBPACK FOOTER //
// ./app/lib/smartorg-api/messaging.js